import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/storage'
import 'firebase/auth';
import 'firebase/functions'
 var config = {
    apiKey: "AIzaSyCrVjyfjZ8H2As8udBbc7W_pEZURNJla78",
    authDomain: "bioagescore.firebaseapp.com",
    databaseURL: "https://bioagescore.firebaseio.com",
    projectId: "bioagescore",
    storageBucket: "bioagescore.appspot.com",
    messagingSenderId: "290603296609"
  };
  firebase.initializeApp(config);

  const storage = firebase.storage();
  //firebase.firestore().settings({ timestampsInSnapshots: true });

  export { 
      
    storage, firebase as default
     
  }